import { isAxiosError } from 'axios';

export const isRequestTimeout = (error: unknown): boolean =>
  isAxiosError(error) && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT');
